import { StatGroup, StatStrip } from './StatGroup';
import type { CockpitAdoption } from '../../types';

export function AdoptionStrip({ data }: { data: CockpitAdoption }) {
  return (
    <StatStrip cols={3}>
      <StatGroup label="Onboarded" hero={data.onboarded} caption={`${data.onboarded} of ${data.provisioned} onboarded`} />
      <StatGroup label="Active this period" hero={data.activeThisPeriod} caption="reps who logged in" />
      <StatGroup
        label="Gone dark"
        hero={<span className={data.goneDark > 0 ? 'text-rose-600 dark:text-rose-400' : ''}>{data.goneDark}</span>}
        caption="no login in 7+ days"
      />
    </StatStrip>
  );
}
